export type BackgroundConfig = {
  type: 'none' | 'blur' | 'image'
  url?: string
}

export const backgroundImageUrls = ['1', '2', '3'].map(
  (imageName) => `${process.env.PUBLIC_URL}/backgrounds/${imageName}.jpg`
)
